import React from 'react';
import { Filter } from "../components/Filter/Filter";

require("../utils/Configs");
require("../utils/Settings");
require("../utils/Paths");
require("../utils/Globals");
require("../utils/Search-Params");

function App() {
    return (
        <div className="main" style={{ paddingBottom: "30px" }}>
            <Filter />
        </div> 
    );
}

export default App;